export interface ToastInfo {
  msg: string;
  err: boolean;
  t: number;
}

let toastSet: ((t: ToastInfo) => void) | null = null;
export function bindToast(fn: ((t: ToastInfo) => void) | null) {
  toastSet = fn;
}
export function toast(msg: string, err = false) {
  if (toastSet) toastSet({ msg, err, t: Date.now() });
}
